import React from "react";
import { useTranslation, useAuthentication } from "@repo/core";
import ChangePasswordCard from "./ChangePasswordCard";
import BillingPortalCard from "./BillingPortalCard";
import DeactivateAccountCard from "./DeactivateAccountCard";

/** Account self-service page - the factor-investing counterpart of anp-fe's
 * UserInfoAndSettings.vue, trimmed to the three actions this app owns:
 * password change, billing portal, account deactivation.
 *
 * Card styling deliberately matches Login/Signup (white rounded card with a
 * shadow on a gray page) so the authenticated account screens read as one
 * family with the unauthenticated ones. */
const Profile: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useAuthentication();

  return (
    <div className="flex min-h-[calc(100vh-4rem)] justify-center p-4">
      <div className="w-full max-w-5xl py-8">
        <header className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            {t("profile.title")}
          </h2>
          {user && (
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
              {user.email}
            </p>
          )}
        </header>

        {/* Password on the left, the two account-level actions stacked on the
            right; single column below lg. */}
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
          <div className="w-full lg:max-w-md">
            <ChangePasswordCard />
          </div>
          <div className="flex w-full flex-col gap-6 lg:max-w-md">
            <BillingPortalCard />
            <DeactivateAccountCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
